import { PropsWithChildren } from 'react'

type HeaderContainerProps = {}

export const HeaderContainer = ({
  children
}: PropsWithChildren<HeaderContainerProps>) => {
  return <div>{children}</div>
}
